module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-right-bottom-backplates-remnants.f7f18fdb.png";